import { render, staticRenderFns } from "./PayrollFinalizationEdit.vue?vue&type=template&id=8bd08de6"
import script from "./PayrollFinalizationEdit.vue?vue&type=script&lang=js"
export * from "./PayrollFinalizationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports